import React from 'react';
import { PendingTaskStatus } from 'types/entities/pending-tasks';
import timeFormat from 'utils/time-format';

interface IPendingTaskReadableStatusProps {
    rawStatus: PendingTaskStatus | null;
    updatedAt?: string;
}

const PendingTaskReadableStatus: React.FC<IPendingTaskReadableStatusProps> = ({
    rawStatus,
    updatedAt,
}) => {
    let status: string;

    switch (rawStatus) {
        case PendingTaskStatus.PENDING: {
            status = 'Pending Approval';
            break;
        }
        case PendingTaskStatus.APPROVED: {
            status = updatedAt
                ? `Approved at: ${timeFormat(updatedAt, false)}`
                : 'Approved';
            break;
        }
        case PendingTaskStatus.REJECTED: {
            status = updatedAt
                ? `Rejected at: ${timeFormat(updatedAt, false)}`
                : 'Rejected';
            break;
        }
        default:
            status = '-';
    }

    return (
        <div>
            <span>{status}</span>
        </div>
    );
};

export default PendingTaskReadableStatus;
